
import {Prop, Component, Mixins, Watch} from "vue-property-decorator";
import DatabasePicker from "@/components/pickers/DatabasePicker.vue";
import PickerInputMixin from "@/mixins/PickerInputMixin.vue";

@Component({
  components: {DatabasePicker},
})
export default class AlacakliPicker extends Mixins(PickerInputMixin) {
  @Prop() takipId!: number;
  @Prop() clearable!: string | boolean;
  @Prop() rules!: any;

  get isClearable() {
    return this.clearable || this.clearable === "";
  }

  itemText(item: any): string {
    if (!item) return '';
    if (item.ad || item.soyad) {
      return `${item.ad ?? ''} ${item.soyad ?? ''}`.trim();
    }
    return item.sirket_adi ?? '';
  }

  get displayItems(): any[] {
    const storeName = this.$helper.getTakipStoreName(this.$route.path);
    if (storeName === 'takipDetay') {
      return this.$store.getters['takipDetay/alacaklilar'] || [];
    }
    const wrapper = this.$store.getters['takipEkle/takipAlacaklilar'];
    return (wrapper && Array.isArray(wrapper.data)) ? wrapper.data : [];
  }

  @Watch('displayItems', { immediate: true })
  onDisplayItemsChange(newItems: any[]) {
    this.items = newItems || [];
    this.$nextTick(() => this.autoSelectIfSingle());
  }

  autoSelectIfSingle() {
    const items = this.displayItems;
    const hasSelection = this.localSelectedIds && this.localSelectedIds.length > 0;
    if (items && items.length === 1 && !hasSelection) {
      this.selectedItem = items[0];
      this.input();
    }
  }

  load() {
    // no-op retained for backward compat with any stray callers
  }
}
